import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  Spinner,
  Table,
  Badge,
  // Table,
  //   Badge,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import BootstrapTable from "react-bootstrap-table-next"
// import paginationFactory, {
//   PaginationProvider,
//   PaginationListStandalone,
//   SizePerPageDropdownStandalone,
//   PaginationTotalStandalone,
// } from "react-bootstrap-table2-paginator"
//import paginationFactory from "react-bootstrap-table2-paginator"
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
// import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import * as shooterAction from "../../store/c2hvb3RlckF2YWlsYWJpbGl0eQ/actions"
import { isEmpty } from "lodash"
import { ToastContainer } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import api from "helpers/Api"

const ShooterAvailability = (props) => {
  // const { SearchBar } = Search
  // const { dispatch, searchBtnStyle } = props
  const { dispatch } = props

  const title = "Shooter Availability List"

  const today = moment().format("DD-MM-YYYY")

  // useEffect(() => {
  //    dispatch(shooterAction.loadRecordsMetaData())
  //   dispatch(
  //     shooterAction.loadRecords({
  //       eventDate: today,
  //     })
  //   )
  // }, [])

  //Reducer States
  const update = useSelector(
    (specificstate) => specificstate.shooterAvailability
  )

  const { shooter_available_list = [] } = update

  //Handle Change
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [employeeData, setEmployeeData] = useState({
    shooterDate: "",
  })

  //handle Change
  const handleChange = async (e) => {
    setEmployeeData({ ...employeeData, [e.target.name]: e.target.value })
  }

  //Service modal

  const handleApply = (e) => {
    e.preventDefault()
    var searchDate = employeeData.shooterDate
      ? moment(employeeData.shooterDate).format("YYYY-MM-DD")
      : ""
    var searchFilter = {}

    if (searchDate) {
      searchFilter.eventDate = searchDate
    }
    dispatch(shooterAction.loadRecords(searchFilter))
    setBtnLoader(true)
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
      setBtnLoader(false)
    }, 2000)
  }

  //table data
  console.log(shooter_available_list, "shooter_available_list")

  const branchArrayDetails =
    shooter_available_list &&
    shooter_available_list.data &&
    shooter_available_list.data.length > 0
      ? shooter_available_list.data.map((data) => {
          if (!isEmpty(data.branchId) && !isEmpty(data.branchName)) {
            return data
          }
        })
      : []

  const branchArray =
    !isEmpty(branchArrayDetails) && branchArrayDetails.length > 0
      ? branchArrayDetails.filter((data) => data != undefined)
      : []

  const scheduledShooterDetails =
    shooter_available_list &&
    shooter_available_list.data &&
    shooter_available_list.data.length > 0
      ? shooter_available_list.data.map((data) => {
          if (!isEmpty(data.branchId) && !isEmpty(data.branchName)) {
            return data.scheduledShooter
          }
        })
      : []

  const scheduledShooter =
    !isEmpty(scheduledShooterDetails) && scheduledShooterDetails.length > 0
      ? scheduledShooterDetails.filter((data) => data != undefined)
      : []

  const unassignedShooterDetails =
    shooter_available_list &&
    shooter_available_list.data &&
    shooter_available_list.data.length > 0
      ? shooter_available_list.data.map((data) => {
          if (!isEmpty(data.branchId) && !isEmpty(data.branchName)) {
            return data.unassignedShooter
          }
        })
      : []

  const unassignedShooter =
    !isEmpty(unassignedShooterDetails) && unassignedShooterDetails.length > 0
      ? unassignedShooterDetails.filter((data) => data != undefined)
      : []
  const leaveDetails =
    shooter_available_list &&
    shooter_available_list.data &&
    shooter_available_list.data.length > 0
      ? shooter_available_list.data.map((data) => {
          if (!isEmpty(data.branchId) && !isEmpty(data.branchName)) {
            return data.leave
          }
        })
      : []

  const leaveArray =
    !isEmpty(leaveDetails) && leaveDetails.length > 0
      ? leaveDetails.filter((data) => data != undefined)
      : []

  console.log(leaveArray, "leaveArray")
  console.log(scheduledShooter, "scheduledShooter")
  console.log(scheduledShooter.length, "scheduledShooter")
  console.log(unassignedShooter, "unassignedShooter")

  // Reset functionality

  const [pageLoad, setPageLoad] = useState(false)
  const resetFormDetails = () => {
    setEmployeeData({
      shooterDate: "",
    })
    dispatch(
      shooterAction.loadRecords({
        eventDate: "",
      })
    )
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchShooterDate = employeeData.shooterDate
      ? moment(employeeData.shooterDate).format("YYYY-MM-DD")
      : today

    var searchFilter = {}

    if (searchShooterDate) {
      searchFilter.eventDate = searchShooterDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/asign_unasign_lead_event_schooters`, searchFilter)
      .then((response) => {
        console.log(response.data, "response")

        const equipmentHrExportExcel = !isEmpty(response.data.data)
          ? response.data.data.data.map((data, index) => {
              // slNo = slNo + 1
              // const shooterDate =
              //   !isEmpty(employeeData.shooterDate) && employeeData.shooterDate
              //     ? moment(employeeData.shooterDate).format("DD-MM-YYYY")
              //     : today
              return {
                sNo: index + 1,
                _id: data.branchId,
                branch: (
                  <Table>
                    <tbody>
                      <>
                        <tr key={index}>
                          <td className="font-bold">{data.branchName}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <Table>
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      width: "36%",
                                    }}
                                  >
                                    Scheduled Shooter
                                  </th>
                                  <th
                                    style={{
                                      width: "33%",
                                    }}
                                  >
                                    Unassigned Shooter
                                  </th>
                                  <th
                                    style={{
                                      width: "31%",
                                    }}
                                  >
                                    Leave
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {data.scheduledShooter &&
                                    data.scheduledShooter.length > 0 ? (
                                      data.scheduledShooter.map(
                                        (shooter, index) => {
                                          return (
                                            <tr
                                              key={index}
                                              style={{
                                                borderRight: "0px solid white",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  borderRight: "none",
                                                }}
                                              >
                                                {" "}
                                                {`${shooter.shooterCode} - ${shooter.shooterName} (${shooter.shooterPosition})`}
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-align-center"
                                          colSpan={1}
                                        >
                                          --
                                        </td>
                                      </tr>
                                    )}
                                  </td>
                                  <td>
                                    {data.unassignedShooter &&
                                    data.unassignedShooter.length > 0 ? (
                                      data.unassignedShooter.map(
                                        (shooter, index) => {
                                          return (
                                            <tr
                                              key={index}
                                              style={{
                                                borderRight: "0px solid white",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  borderRight: "none",
                                                }}
                                              >
                                                {" "}
                                                {`${shooter.shooterCode} - ${shooter.shooterName} (${shooter.shooterPosition})`}
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-align-center"
                                          colSpan={1}
                                        >
                                          --
                                        </td>
                                      </tr>
                                    )}
                                  </td>
                                  <td>
                                    {data.leave && data.leave.length > 0 ? (
                                      data.leave.map((shooter, index) => {
                                        return (
                                          <tr
                                            key={index}
                                            style={{
                                              borderRight: "0px solid white",
                                            }}
                                          >
                                            <td
                                              style={{
                                                borderRight: "none",
                                              }}
                                            >
                                              {" "}
                                              {`${shooter.shooterCode} - ${shooter.shooterName} (${shooter.shooterPosition})`}
                                            </td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-align-center"
                                          colSpan={1}
                                        >
                                          --
                                        </td>
                                      </tr>
                                    )}
                                  </td>
                                </tr>
                                {/* {} */}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </>
                    </tbody>
                  </Table>
                ),
                // shooterDate: shooterDate ? shooterDate : "--",
                // scheduleShooter: data.scheduleShooter
                //   ? data.scheduleShooter
                //   : "--",
                // unassignedShooter: data.unassignedShooter
                //   ? data.unassignedShooter
                //   : "--",
                // leave: data.leave ? data.leave : "--",
                // status: data.status,
              }
            })
          : []
        setTimeout(() => {
          let headerData = ["Branch"]

          let usersCsv = !isEmpty(equipmentHrExportExcel)
            ? equipmentHrExportExcel.reduce((acc, user) => {
                const {
                  // sNo,
                  // shooterDate,
                  branch,
                  // scheduleShooter,
                  // unassignedShooter,
                  // leave,
                } = user
                acc.push([
                  // sNo,
                  // shooterDate,
                  branch,
                  // scheduleShooter,
                  // unassignedShooter,
                  // leave,
                ])

                console.log("test", acc)
                return acc
              }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "ShooterAvailability.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Event To Date"}>
                          {"Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="shooterDate"
                        value={employeeData.shooterDate}
                        min={employeeData.fromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleApply(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <Row>
                  <Col md="4"></Col>
                  <Col md="8">
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                          marginBottom: "20px",
                          marginTop: "0px",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Col>
                  <Table>
                    <thead>
                      <tr style={{ fontWeight: "600", fontSize: "12px" }}>
                        <td>Branch</td>
                      
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(shooter_available_list) &&
                      shooter_available_list.date ? (
                        <>
                          {" "}
                          <tr>
                         
                            <td>
                              <Table>
                                <tbody>
                                  {branchArray && branchArray.length > 0 ? (
                                    branchArray.map((data, index) => {
                                      return (
                                        <>
                                          <tr key={index}>
                                            <td className="font-bold">
                                              {data.branchName}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colSpan={2}>
                                              <Table>
                                                <thead>
                                                  <tr>
                                                    <th
                                                      style={{
                                                        width: "34%",
                                                      }}
                                                      // className="d-flex flex-row"
                                                    >
                                                      Scheduled Shooter
                                                      <Badge
                                                        color="success"
                                                        className="mx-1 px-1"
                                                      >
                                                        {data.scheduledShooter &&
                                                        data.scheduledShooter
                                                          .length > 0
                                                          ? data
                                                              .scheduledShooter
                                                              .length
                                                          : 0}
                                                      </Badge>
                                                    </th>
                                                    <th
                                                      style={{
                                                        width: "35%",
                                                      }}
                                                      // className="d-flex flex-row"
                                                    >
                                                      Unassigned Shooter
                                                      <Badge
                                                        color="success"
                                                        className="mx-1 px-1"
                                                      >
                                                        {data.unassignedShooter &&
                                                        data.unassignedShooter
                                                          .length > 0
                                                          ? data
                                                              .unassignedShooter
                                                              .length
                                                          : 0}
                                                      </Badge>
                                                    </th>
                                                    <th
                                                      style={{
                                                        width: "31%",
                                                      }}
                                                      // className="d-flex flex-row"
                                                    >
                                                      Leave
                                                      <Badge
                                                        color="success"
                                                        className="mx-1 px-1"
                                                      >
                                                        {data.leave &&
                                                        data.leave.length > 0
                                                          ? data.leave.length
                                                          : 0}
                                                      </Badge>
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      {data.scheduledShooter &&
                                                      data.scheduledShooter
                                                        .length > 0 ? (
                                                        data.scheduledShooter.map(
                                                          (shooter, index) => {
                                                            return (
                                                              <tr
                                                                key={index}
                                                                style={{
                                                                  borderRight:
                                                                    "0px solid white",
                                                                }}
                                                              >
                                                                <td
                                                                  style={{
                                                                    borderRight:
                                                                      "none",
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  {`${shooter.shooterCode} - ${shooter.shooterName} (${shooter.shooterDepartment}- ${shooter.shooterPosition})`}
                                                                </td>
                                                              </tr>
                                                            )
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            className="text-align-center"
                                                            colSpan={1}
                                                          >
                                                            --
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </td>
                                                    <td>
                                                      {data.unassignedShooter &&
                                                      data.unassignedShooter
                                                        .length > 0 ? (
                                                        data.unassignedShooter.map(
                                                          (shooter, index) => {
                                                            return (
                                                              <tr
                                                                key={index}
                                                                style={{
                                                                  borderRight:
                                                                    "0px solid white",
                                                                }}
                                                              >
                                                                <td
                                                                  style={{
                                                                    borderRight:
                                                                      "none",
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  {`${shooter.shooterCode} - ${shooter.shooterName} (${shooter.shooterDepartment}- ${shooter.shooterPosition})`}
                                                                </td>
                                                              </tr>
                                                            )
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            className="text-align-center"
                                                            colSpan={1}
                                                          >
                                                            --
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </td>
                                                    <td>
                                                      {data.leave &&
                                                      data.leave.length > 0 ? (
                                                        data.leave.map(
                                                          (shooter, index) => {
                                                            return (
                                                              <tr
                                                                key={index}
                                                                style={{
                                                                  borderRight:
                                                                    "0px solid white",
                                                                }}
                                                              >
                                                                <td
                                                                  style={{
                                                                    borderRight:
                                                                      "none",
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  {`${shooter.shooterCode} - ${shooter.shooterName} (${shooter.shooterDepartment}- ${shooter.shooterPosition})`}
                                                                </td>
                                                              </tr>
                                                            )
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            className="text-align-center"
                                                            colSpan={1}
                                                          >
                                                            --
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </td>
                                                  </tr>
                                                  {/* {} */}
                                                </tbody>
                                              </Table>
                                            </td>
                                          </tr>
                                        </>
                                      )
                                    })
                                  ) : (
                                    <tr>
                                      <td
                                        className="text-align-center"
                                        colSpan={6}
                                      >
                                        No Record Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td className="text-align-center" colSpan={6}>
                            No Events Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
                {/* <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={shooterDataTable}
                      columns={columns}
                      search
                      exportCSV={{
                        onlyExportFiltered: true,
                        exportAll: false,
                      }}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col md="8">
                                <div
                                  style={{
                                    float: "right",
                                  }}
                                >
                                  <Button
                                    className="btn btn-primary"
                                    onClick={exportToCsv}
                                    id="download"
                                    style={{
                                      backgroundColor: "#e40d8c",
                                      color: "white",
                                      border: "none",
                                      marginBottom: "20px",
                                      marginTop: "0px",
                                    }}
                                  >
                                    Download
                                  </Button>
                                </div>
                              </Col>
                              <Col md="12" lg="12" xl="12" sm="12" xs="12">
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  keyField="_id"
                                  bordered={true}
                                  columns={columns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider> */}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "6.7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
ShooterAvailability.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShooterAvailability)
)
